/**
 * Represents a collection of custom select elements.
 * @type {NodeListOf<Element>}
 */
const customSelects = document.querySelectorAll(".custom-select");

/**
 * Handles custom select elements
 * @param {HTMLElement} selectElement - the select element to handle
 * @param {boolean} isClear - whether to clear the select element
 * @returns {void}
 */
const handleCustomSelects = (selectElement, isClear) => {
    const parentElement = selectElement.parentElement;
    isClear ? parentElement.classList.remove("opened") : parentElement.classList.toggle("opened");
};

/**
 * Binds events to the custom select elements.
 * Iterates over each custom select element and calls the handleCustomSelects function.
 */
const bindEvents = () => {
    customSelects.forEach((selectElement) => {
        selectElement.addEventListener("click", () => {
            handleCustomSelects(selectElement, false);
        });

        selectElement.addEventListener("blur", () => {
            handleCustomSelects(selectElement, true);
        });
    });
};

module.exports = {
    bindEvents
};
